import { registerDenoiserExtension } from './noiseCancellation';

// Skip the eager AI Denoiser registration for recorder bot URLs. Bots
// subscribe to already-published audio and never publish their own track,
// so denoising is useless overhead. The WASM blob (~MB-scale) loaded by
// the extension only delays page-load on the bot Chrome, which makes
// startup white-screen worse and may push notifyReady past Agora's bot
// deadline. Real users still get denoising — they have a microphone track
// to publish, the gate skips only the recorder-bot URL pattern.
const isRecorderURL = typeof window !== 'undefined' && (
  new URLSearchParams(window.location.search).get('recorder') === 'true' ||
  window.location.pathname.startsWith('/recording-view')
);
if (!isRecorderURL) {
  registerDenoiserExtension();
} else {
  console.log('[noiseCancellationInit] recorder URL detected — skipping AI Denoiser registration');
}
